import axios from "axios";
import { Config } from "../Config";
import { userAccessToken } from "../helpers";

export const setLetterCredit = async (data) => {
    try {
      const response = await axios.post(`${Config.notificationServerUrl}/letter-config/create-config`, data,
        {
          headers: {
            "Content-Type": "application/json",
            accept: "application/json",
            Authorization: `Bearer ${userAccessToken()}`,
          },
        }
      );
      return response;
    } catch (error) {
      return error;
    }
  };


  export const getLetterLimitData = async (account_id) => {
    try {
      const response = await axios.get(
        `${Config.notificationServerUrl}/letter-config/get-by-account-id?account_id=${account_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            accept: "application/json",
            Authorization: `Bearer ${userAccessToken()}`,
          },
        }
      );
      return response;
    } catch (error) {
      return error;
    }
  };


  export const fetchletter = async (filter, account_id) => {
    const { page, per_page, search_term, message_type, order_by } = filter;
  
    try {
      const searchParam = search_term ? `&search_term=${search_term}` : "";
      const messageType = message_type ? `&message_type=${message_type}` : "";
      let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";
      const response = await axios.get(
        `${Config.notificationServerUrl}/letter-transaction/letter-transactions?account_id=${account_id}&page=${page}&per_page=${per_page}${searchParam}${messageType}${orderBy}`,
        {
          headers: {
            "Content-Type": "application/json",
            accept: "application/json",
            Authorization: `Bearer ${userAccessToken()}`,
          },
        }
      );
      return response;
    } catch (error) {}
  };